import { ThemeOptions } from '@mui/material/styles/createTheme';

import { tokens } from '../../../theme/generated/tokens';
import { cssVars } from '../../../utils/cssVars';

const vars = cssVars(
  {
    strengthLevel: undefined,
    strengthBarColor: undefined,
    strengthTextColor: undefined,
  },
  'ds-password'
);

export const passwordInputTheme: ThemeOptions['components'] = {
  DsPasswordInput: {
    styleOverrides: {
      root: () => ({
        '& .DS-Input-adornment-root svg': {
          cursor: 'pointer',
        },
        '& .DS-Password-strength-root': {
          display: 'flex',
          flexDirection: 'column',
          fontWeight: '400',

          '& .DS-Password-strength-title': {
            fontWeight: '500',
          },

          '&.DS-Password-strength-': {
            '&weak': vars.setValues({
              strengthLevel: '25%',
              strengthBarColor: tokens.theme.bg.status.errorStrong,
              strengthTextColor: tokens.theme.fg.status.error,
            }),
            '&medium': vars.setValues({
              strengthLevel: '50%',
              strengthBarColor: tokens.theme.bg.status.warningStrong,
              strengthTextColor: tokens.theme.fg.status.warning,
            }),
            '&good': vars.setValues({
              strengthLevel: '75%',
              strengthBarColor: tokens.theme.bg.status.infoStrong,
              strengthTextColor: tokens.theme.fg.status.info,
            }),
            '&strong': vars.setValues({
              strengthLevel: '100%',
              strengthBarColor: tokens.theme.bg.status.successStrong,
              strengthTextColor: tokens.theme.fg.status.success,
            }),
          },
          '& .DS-Password-strength-indicatorRow': {
            display: 'flex',
            alignItems: 'center',
            '& .DS-Password-strength-title': {
              flexGrow: 0,
              color: vars.refs.strengthTextColor,
              minWidth: '4.5em',
            },
            '& .DS-Password-strength-indicatorContainer': {
              borderRadius: tokens.theme.radius.sm,
              flexGrow: 1,
              display: 'flex',
              height: '4px',
              alignItems: 'stretch',
              backgroundColor: tokens.theme.bg.structural.surfaceRaised,
              '& .DS-Password-strength-indicator': {
                borderRadius: 'inherit',
                backgroundColor: vars.refs.strengthBarColor,
                flexBasis: vars.refs.strengthLevel,
              },
            },
          },
        },
      }),
    },
  },
};
